import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#fff",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.00018 0.341797C6.36966 0.341819 6.70459 0.498071 6.9494 0.750977C6.98111 0.777859 7.01221 0.805986 7.04217 0.835938L10.6525 4.44629C11.2125 5.00641 11.2365 5.88967 10.7062 6.41992C10.176 6.95012 9.29271 6.9262 8.7326 6.36621L7.3576 4.99121V10.2236C7.35751 11.0157 6.75003 11.6582 6.00018 11.6582C5.2503 11.6582 4.64187 11.0157 4.64178 10.2236V4.99121L3.26776 6.36523C2.70771 6.92494 1.82433 6.94887 1.29412 6.41895C0.763839 5.88866 0.787715 5.00446 1.34783 4.44434L4.95819 0.834961C4.9948 0.798349 5.03228 0.763472 5.07147 0.731445C5.31439 0.490462 5.64062 0.341797 6.00018 0.341797Z" })
});
export default SvgArrowUp;
